import { useState, useEffect } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteFooter() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {showTop && (
        <a
          href="#top"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lift transition hover:bg-primary-400"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </a>
      )}

      <footer className="bg-accent-950 text-accent-100">
        <div className="container-site grid grid-cols-1 gap-10 py-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                <span className="text-lg">🍉</span>
              </span>
              <span className="text-lg font-black text-background-50">
                嗑瓜<span className="text-secondary-300">星球</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-accent-100/80">
              国产吃瓜社区与论坛聚集地。实时热榜、犀利热评、群聊对暗号、树洞倾诉，评论区全天候开放。理性吃瓜、尊重事实，把氛围玩出家的感觉。
            </p>
            <div className="mt-5 flex items-center gap-3 text-lg">
              <a href="#top" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-800/60 text-accent-100 transition hover:bg-accent-700"><i className="ri-weibo-line"></i></a>
              <a href="#top" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-800/60 text-accent-100 transition hover:bg-accent-700"><i className="ri-music-2-line"></i></a>
              <a href="#top" aria-label="小红书" className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-800/60 text-accent-100 transition hover:bg-accent-700"><i className="ri-bookmark-3-line"></i></a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-accent-100/80 transition hover:text-secondary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">社区公约</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-accent-100/80">
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-secondary-300"></i>理性吃瓜 尊重事实</li>
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-secondary-300"></i>不恶意造谣 不人身攻击</li>
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-secondary-300"></i>保护隐私 守住底线</li>
              <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-secondary-300"></i>友善讨论 快乐追更</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-accent-800/60">
          <div className="container-site flex flex-col items-center justify-between gap-2 py-5 text-center text-xs text-accent-100/70 sm:flex-row sm:text-left">
            <p>© {new Date().getFullYear()} 嗑瓜星球 · 国产吃瓜社区与论坛. All rights reserved.</p>
            <p className="flex items-center gap-1.5">
              内容仅供参考讨论 · 理性吃瓜 <i className="ri-heart-3-fill text-secondary-300"></i>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}